module.exports = __webpack_public_path__ + "static/insurance-34a217faf5ed96da00598800ff3098a0.jpg";